<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div id="interview-practice">
      <div class="interview-practice-container">
        <section class="first">
          <div class="renew2_wrapper">
            <h2>AI面接練習(β版)</h2>
            <div class="">
              <div class="first-flexright">
                <div class="first01">
                  <p class="first01-title">志望企業の情報や志望動機を入力！</p>
                  <p class="first01-txt">
                    AIヤギが、あなたが入力した情報に沿って質問をしてくれます。<br>さっそく入力して、面接の練習を始めましょう！<br>※情報は入力しなくても始めることができます。</p>
                </div>
                <form @submit.prevent="submitForm">
                  <div class="form-group">
                    <label for="companyInfo">志望企業の情報</label>
                    <textarea id="companyInfo" v-model="companyInfo" rows="4" placeholder="企業名、業界、特徴など"
                      class="el-textarea__inner"></textarea>
                  </div>
                  <div class="form-group">
                    <label for="motivation">志望動機</label>
                    <textarea id="motivation" v-model="motivation" rows="4" placeholder="なぜこの企業を志望しているのか、どのように貢献したいかなど"
                      class="el-textarea__inner"></textarea>
                  </div>
                  <button type="submit" class="submit-button">ログインして始める</button>
                </form>
              </div>
            </div>
          </div>
          <div
            class="renew2_wrapper mt-2"
            v-if="isSubscribed"
          >
            <h3 class="interview-practice-history-h3">面接練習履歴</h3>
            <div class="history-container">
              <div v-for="history in interviewHistory" :key="history.ai_interview_practice_id" class="history-item">
                <div class="date">{{ formatDate(history.update_date) }}</div>
                <div class="company-info">{{ history.company_info ? history.company_info : 'なし' }}</div>
                <button @click="continueInterview(history)" class="continue-button">続き</button>
                <button @click="deleteInterview(history.ai_interview_practice_id)" class="delete-button">削除</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      companyInfo: '',
      motivation: '',
      isSubscribed: false,
      interviewHistory: [],
      fullscreenLoading: false,
    }
  },
  mounted() {
    this.authStateChanged()
  },
  methods: {
    async fetchConversationHistory () {
      // 面接練習履歴を取得する処理を実装
      const response = await this.$axios.post(this.$varuna.endPoints.interviewHistory, {
        uuid: this.$firebase.user.uid
      })
      const data = await response.data
      this.interviewHistory = data.data
    },
    continueInterview (history) {
      this.$emit('form-submitted', {
        companyInfo: history.company_info,
        motivation: history.reason,
        previousMessages: history.conversation // 履歴のチャットログを渡す
      })
    },
    deleteInterview (id) {
      this.$axios.post(this.$varuna.endPoints.deleteInterview, {
        ai_interview_practice_id: id
      }).then(() => {
        this.fetchConversationHistory()
      }).catch((error) => {
        console.error('面接練習の削除中にエラーが発生しました:', error)
      })
    },
    async fetchIsUserPrimeRegistered() {
      if (!this.$firebase.isAuthenticated) {
        console.log('ユーザーがログインしていません')
        return
      }
      try {
        const response = await this.$axios.get(this.$varuna.endPoints.isSubscribed + this.$firebase.user.uid + '/')
        const data = await response.data
        this.isSubscribed = data.is_subscribed

        if (this.isSubscribed) {
          // Prime会員ではない場合は、始めるボタン(submit-button)を会員登録ボタンに変更
          const submitButton = document.querySelector('.submit-button')
          submitButton.textContent = '面接練習を始める'
        } else {
          // Prime会員ではない場合は、始めるボタン(submit-button)を会員登録ボタンに変更
          const submitButton = document.querySelector('.submit-button')
          submitButton.textContent = 'ヤギプライムに登録して始める'
        }

      } catch (error) {
        console.error('Prime会員情報の取得中にエラーが発生しました:', error)
        this.isUserPrimeRegistered = false
      }
    },
    async fetchMotivation() {
      if (!this.$firebase.isAuthenticated) {
        console.log('ユーザーがログインしていません')
        return
      }
      try {
        const response = await this.$axios.post(this.$varuna.endPoints.aiGetMotivation, {
          uuid: this.$firebase.user.uid
        })
        const data = await response.data

        // 志望動機が存在する場合のみセット、ない場合はnullのまま
        this.motivation = data.motivation || null
      } catch (error) {
        console.error('志望動機の取得中にエラーが発生しました:', error)
        this.motivation = null
      }
    },
    submitForm: function () {
      if (!this.$firebase.isAuthenticated) {
        // /loginにリダイレクト
        window.location.href = '/login'
        return
      }
      if (!this.isSubscribed) {
        // Prime会員ではない場合は、/primeにリダイレクト
        window.location.href = '/yagiprime_register'
        return
      }
      this.$emit('form-submitted', {
        companyInfo: this.companyInfo,
        motivation: this.motivation,
        previousMessages: []
      })
    },
    formatDate (date) {
      const d = new Date(date)
      const year = d.getFullYear()
      const month = ('00' + (d.getMonth() + 1)).slice(-2)
      const day = ('00' + d.getDate()).slice(-2)
      const hours = ('00' + d.getHours()).slice(-2)
      const minutes = ('00' + d.getMinutes()).slice(-2)
      return `${year}-${month}-${day}\n${hours}:${minutes}`
    },
    authStateChanged: async function () {
      const app = this
      app.fullscreenLoading = true
      if (this.$firebase.isAuthenticated) {
        await this.fetchIsUserPrimeRegistered()
        await this.fetchConversationHistory()
        app.fullscreenLoading = false
        // await this.fetchMotivation()
      }
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('firebase-initialized', this.authStateChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('firebase-initialized', this.authStateChanged)
  },
}
</script>

<style scoped>
#interview-practice .renew2_wrapper {
  width: 768px;
}

#interview-practice a:hover {
  text-decoration: none;
  opacity: 1;
}

#interview-practice h2 {
  font-size: 18px;
  color: #004D40;
  text-align: center;
  margin-bottom: 20px;
}

#interview-practice h3 {
  margin-bottom: 5px;
}

#interview-practice .first {
  background: #FFFFE8;
  padding: 30px 0;
  margin-bottom: 50px;
}

#interview-practice .first01 {
  margin-bottom: 20px;
}

#interview-practice .first01-title {
  color: #E95B10;
  font-weight: bold;
  font-size: 16px;
}

#interview-practice .first .renew2_flex {
  justify-content: space-between;
}

.mt-2 {
  margin-top: 50px;
}

.justify-content-space-around {
  justify-content: space-around;
}

h2 {
  font-size: 24px;
  margin-bottom: 10px;
  color: #333;
}

.form-group {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #333;
}

label:hover {
  color: #333;
  opacity: 1;
}

.submit-button {
  background-color: #4CAF50;
  color: white;
  padding: 12px 30px;
  border-radius: 50px;
  border: 3px solid #004D40;
  box-shadow: 0 3px 0 #004d40;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
  display: block;
  margin: 0 auto;
}

.submit-button:hover {
  opacity: 1;
  transform: translateY(3px);
  box-shadow: none;
}

.history-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.history-item {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  border: 1px solid #dcdfe6;
  padding: 15px;
  border-radius: 8px;
}

.company-info,
.motivation {
  width: 30%;
  font-size: 16px;
  color: #333;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.continue-button {
  background-color: #4CAF50;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.continue-button:hover {
  background-color: #45a049;
}

.delete-button {
  background: none;
  color: #E3165C;
  border: none;
  cursor: pointer;
}


@media (max-width: 768px) {
  .pre-interview-form {
    padding: 15px;
  }

  h2 {
    font-size: 20px;
  }

  p {
    font-size: 14px;
  }

  .submit-button {
    width: 100%;
  }

  .history-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .company-info,
  .motivation {
    width: 100%;
  }

  .continue-button {
    margin: 10px auto 15px;
    width: 100%;
  }

  .delete-button {
    margin: 0 auto;
  }
}
</style>
